<template>
  <div class="wrapper">
    <div class="award-name">
      <div class="name">
        {{ award_total > 1 ? prize_order[award_idx] + "等奖：" : "奖品："
        }}{{ title }}
      </div>
      <div class="fill-tip">请填写以下信息领奖</div>
    </div>
    <div class="boxs">
      <div class="form-item">给发起人留言</div>
      <div class="form-item" v-if="award_wx" @click="copyWx(award_wx)">
        <div class="label">微信号</div>
        <div class="award_wx">
          {{ award_wx }}<span class="copy-text">复制</span>
        </div>
      </div>
      <div class="contact position-r" @click="toMessage">
        去输入留言信息 >
        <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
      </div>
      <div class="form-img-box">
        <div class="title">出示领奖码</div>
        <img
          :src="prurl"
          alt="分享图片"
          id="posterIimg"
          class="poster-img"
          v-show="hidden"
        />
        <div class="tipbottom" v-if="prurl">长按图片保存到手机</div>
        <template v-else>
          <van-loading type="spinner" vertical>正在生成图片...</van-loading>
        </template>
        <div class="img-box" id="img-box" v-if="avatar && qrcode">
          <div class="header flexCenter">
            <img :src="avatar" alt="" />
            <div>
              <p class="uname">{{ uname }}</p>
              <p class="ques_title">{{ ques_title }}</p>
            </div>
          </div>
          <div class="img-content">
            <p class="title">获得奖品</p>
            <p class="name">{{ title }}</p>
            <img :src="qrcode" alt="" />
            <p>管理员扫码，验证中奖信息</p>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <ImgDialog :src="settingSrc" />
    </van-popup>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import questionOnly from "@/utils/questionOnly";
import { Toast } from "vant";
import { getToken, setShareInfo, reLogin, isWeixin, isMobile, getWxUrl, getDetailWxCode } from "@/utils/common";
import WxLink from "@/components/wxLink.vue";
import ImgDialog from "@/components/common/imgDialog.vue";


export default {
  data() {
    return {
      prize_order: "一二三四五六七八九十",
      award_idx: 0,
      award_total: 1,
      award_contact: "",
      award_wx: "",
      preImg: "",
      rid: "",
      prurl: "",
      qrcode: "",
      qid: "",
      title: "",
      unionid: "",
      score: "",
      uname: "",
      avatar: "",
      ques_title: "",
      award_wx: "",
      award_contact: "",
      hidden: false,
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      settingUrl: '',
      settingSrc: '',
      showVersionTip: false,
      wxPath: "/pages/detail/detail?qid=",
    };
  },
  mounted() {
    this.rid = this.$route.query.rid;
    this.getAwardDetail(this);
    setShareInfo(false);
  },
  components: {
    WxLink,
    ImgDialog
  },
  methods: {
    copyWx(desc) {
      this.$copyText(desc);
      Toast("复制成功");
    },
    async toMessage() {
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.qid, 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        if (!this.settingSrc) {
          this.settingSrc = await getDetailWxCode(this.qid);
        }
        this.showVersionTip = true;
      }
    },
    copySuccess() {
      Toast("复制成功");
    },
    getQrcode() {
      let data = {
        qid: this.rid,
        mode: 4,
        access_token: getToken()
      };
      questionOnly.get("/xcx/ques/v1/qrcode", data).then(res => {
        if (res.sta == 0) {
          this.qrcode = res.data.url;
          setTimeout(() => {
            this.canvasPaint();
          }, 1000);
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    getAwardDetail(self) {
      let param = {
        rid: self.rid,
        access_token: getToken()
      };
      questionOnly.get("/xcx/ques/v2/award/detail", param).then(res => {
        if (res.sta == 0) {
          let d = res.data;
          this.qid = d.qid;
          this.title = d.title;
          this.unionid = d.unionid;
          this.score = d.score;
          this.rid = d.rid;
          this.uname = d.uname;
          this.avatar = d.avatar;
          this.ques_title = d.ques_title;
          this.award_wx = d.award_wx;
          this.award_contact = d.award_contact;
          this.award_total = d.award_total;
          this.award_idx = d.award_idx;
          self.getQrcode();
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    canvasPaint() {
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      const domObj = document.getElementById("img-box");
      let width = domObj.offsetWidth; //获取dom 宽度
      let height = domObj.offsetHeight; //获取dom 高度
      let canvas = document.createElement("canvas"); //创建一个canvas节点
      const scale = 2; //定义任意放大倍数 支持小数
      canvas.width = width * scale; //定义canvas 宽度 * 缩放
      canvas.height = height * scale; //定义canvas高度 *缩放
      let context = canvas.getContext("2d");
      // 【重要】关闭抗锯齿
      context.mozImageSmoothingEnabled = false;
      context.webkitImageSmoothingEnabled = false;
      context.msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      let opts = {
        // 注意：  allowTaint: true  和 useCORS: true 不能同时设置，两者只有一个起作用
        scale: scale, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        // allowTaint: true, // 允许污染，允许画布上有跨域图片 不建议使用 后面详细补充
        logging: true, //日志开关，便于查看html2canvas的内部执行流程
        width: width, //dom 原始宽度
        height: height,
        dpi: 300,
        useCORS: true, // 【重要】开启跨域配置
        letterRendering: true
      };
      html2canvas(domObj, opts).then(canvas => {
        // 在微信里,可长按保存或转发
        this.prurl = canvas.toDataURL("image/png");
        let detail = document.getElementById("posterIimg"); // 防止图片url的标签的id
        detail.style.width = canvas.width / 2 + "px";
        detail.style.height = canvas.height / 2 + "px";
        this.hidden = true;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding-bottom: env(safe-area-inset-bottom);
  position: relative;
  max-width: 500px;
  min-width: 320px;
  font-size: 14px;
  margin: 0 auto
}
.header {
  margin: 10px 15px;
  font-size: 13px;
  line-height: 1.5;
  color: #666;
}

.form-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  font-size: 15px;
  color: #333;
  margin-bottom: 15px;
}

.form-item .wx-no {
  max-width: 190px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.right-icon {
  width: 28px;
  height: 28px;
  margin-left: 5px;
}

.qrcode {
  display: block;
  margin: 0 auto 15px;
  width: 308.5px;
  border-radius: 10px;
}

.btn {
  margin: 0 auto;
  width: 345px;
  height: 45px;
  line-height: 45px;
  font-size: 15px;
  color: #fff;
  background: #1890ff;
  border-radius: 2px;
  text-align: center;
}

.canvas {
  position: absolute;
  left: -1500px;
  top: -2500px;
  width: 370px;
  height: 448px;
  background: #fff;
}

.contact {
  background: #f7f7f7;
  height: 41.5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  color: #999999;
  font-size: 15px;
}

.award-name {
  padding: 40px 15px 0;
  text-align: center;
  font-size: 16px;
}

.tip {
  color: #a8071a;
  font-size: 14px;
  margin-top: 7.5px;
}

.fill-tip {
  padding: 20px 0;
  border-top: 1px dashed #cccccc;
  margin-top: 20px;
  color: #262626;
}

.save-tips {
  font-size: 14px;
  color: #999999;
  margin: 20px 12.5px;
}

.boxs {
  margin: 0 15px;
  background: #ffffff;
  padding: 25px 15px;
  border-radius: 10px;
}
.copy-text {
  color: #a8071a;
  font-size: 15px;
  margin-left: 8px;
}
.award_wx {
  display: flex;
  align-items: center;
}
.form-img-box {
  background: #fff;
  margin-top: 10px;
  color: #333;
  position: relative;
}
.form-img-box .title {
  height: 40px;
  line-height: 40px;
  margin-bottom: 15px;
  font-size: 15px;
}

.img-box {
  background: #2674ff;
  padding: 20px 15px 30px;
  position: absolute;
  left: 0;
  top: -2000px;
  width: calc(100% - 30px);
  // border-radius: 10px;
  .header {
    color: #ffffff;
    .uname {
      font-size: 16px;
      font-weight: bold;
      overflow: hidden;
    }
    .ques_title {
      font-size: 14px;
      margin-top: 3px;
    }
    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 10px;
    }
  }
  .img-content {
    background: #fff;
    text-align: center;
    padding: 5px 0 15px;
    color: #666;
    border-radius: 4px;
    font-size: 15px;
    img {
      width: 150px;
      height: 150px;
      margin: 15px 0;
    }
    .name {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
.qrcode {
  display: block;
  margin: 0 auto rem(30);
  width: rem(617);
}
.tipbottom {
  margin: 15px auto;
  line-height: 45px;
  font-size: 13px;
  color: #999;
  text-align: center;
}

.canvas {
  position: absolute;
  left: -3000px;
  top: -5000px;
  width: rem(740);
  height: rem(896);
  background: #fff;
}
#posterIimg {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/award/cash.vue